<template>

    <div class="setting-block">

        <v-row>
            <v-col cols="12" md="6" class="py-0">
                <ValidationObserver ref="viberTokenForm" v-slot="{  }">
                    <ValidationProvider name="viber_token"
                                        rules="required"
                                        v-slot="{ errors, dirty }"
                                        tag="div"
                                        class="setting-bot-card-wrap"
                    >
                        <v-card>
                            <v-toolbar class="elevation-0" color="blue lighten-5">
                                <v-toolbar-title>Настройки Viber бота</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="success"
                                               small
                                               fab
                                               depressed
                                               v-on="on"
                                               :disabled="!dirty"
                                               @click.prevent="saveViberToken"
                                        >
                                            <v-icon>mdi-content-save</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Сохранить изменения</span>
                                </v-tooltip>
                            </v-toolbar>
                            <v-card-text class="pa-6">
                                <v-row>
                                    <v-col cols="12" class="pb-0">
                                        <v-text-field
                                                type="text"
                                                v-model="viber_token"
                                                label="Viber токен"
                                                outlined
                                                :error-messages="errors"
                                        />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </ValidationProvider>
                </ValidationObserver>
            </v-col>

            <v-col cols="12" md="6" class="py-0" :style="{marginTop: $vuetify.breakpoint.smAndDown ? '60px' : 0}">
                <ValidationObserver ref="telegramTokenForm" v-slot="{  }">
                    <ValidationProvider name="telegram_token"
                                        rules="required"
                                        v-slot="{ errors, dirty }"
                                        tag="div"
                                        class="setting-bot-card-wrap"
                    >
                        <v-card>
                            <v-toolbar class="elevation-0" color="blue lighten-5">
                                <v-toolbar-title>Настройки Telegram бота</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="success"
                                               small
                                               fab
                                               depressed
                                               v-on="on"
                                               :disabled="!dirty"
                                               @click.prevent="saveTelegramToken"
                                        >
                                            <v-icon>mdi-content-save</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Сохранить изменения</span>
                                </v-tooltip>
                            </v-toolbar>
                            <v-card-text class="pa-6">
                                <v-row>
                                    <v-col cols="12" class="pb-0">
                                        <v-text-field
                                                type="text"
                                                v-model="telegram_token"
                                                label="Telegram токен"
                                                outlined
                                                :error-messages="errors"
                                        />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </ValidationProvider>
                </ValidationObserver>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import profileApi from '../api/profile.api';

    export default {
        name   : "SettingsBots",
        data() {
            return {
                viber_token   : '',
                telegram_token: '',
            }
        },
        created() {
            this.viber_token = this.$auth.user().viber_token;
            this.telegram_token = this.$auth.user().telegram_token;
        },
        methods: {
            async saveViberToken() {
                let confirmed = false;

                if (!this.$auth.user().viber_token) {
                    confirmed = true;
                } else {
                    confirmed = await this.$confirm('Вы уверены что хотите установить новый токен для Viber бота?');
                }

                if (true === confirmed) {
                    this.$store.commit('setLoading', true);

                    profileApi.setViberToken(this.viber_token).then(({data}) => {
                        this.$auth.user(data.data);
                        this.$refs.viberTokenForm.reset();
                    }).catch(() => {
                        this.$refs.viberTokenForm.setErrors({viber_token: ['Проверьте токен и повторите попытку']});
                    }).finally(() => {
                        this.$store.commit('setLoading', false);
                    });
                }
            },
            async saveTelegramToken() {
                let confirmed = false;

                if (!this.$auth.user().telegram_token) {
                    confirmed = true;
                } else {
                    confirmed = await this.$confirm('Вы уверены что хотите установить новый токен для Telegram бота?');
                }

                if (true === confirmed) {
                    this.$store.commit('setLoading', true);

                    profileApi.setTelegramToken(this.telegram_token).then(({data}) => {
                        this.$auth.user(data.data);
                        this.$refs.telegramTokenForm.reset();
                    }).catch(() => {
                        this.$refs.telegramTokenForm.setErrors({telegram_token: ['Проверьте токен и повторите попытку']});
                    }).finally(() => {
                        this.$store.commit('setLoading', false);
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
